import { defaultTo } from 'lodash';
import { IModel, Model } from '.';

export interface ILicenseTypeModel extends IModel {
  licenseTypeId: number;
  name: string;
}

export class LicenseTypeModel extends Model implements ILicenseTypeModel {
  licenseTypeId: number;
  name: string;

  constructor(params?: Partial<ILicenseTypeModel>) {
    super(params);
    this.licenseTypeId = defaultTo(params?.licenseTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
